import { useEditor, useNode } from '@craftjs/core';
import { SwitchControl } from 'pages/PageEditor/settingsComponents';
import React, { useCallback } from 'react';
import { EditorInputSettings } from './EditorInput/EditorInputSettings';

type Props = {
	// eslint-disable-next-line react/require-default-props
	children?: JSX.Element | JSX.Element[];
};

const EditorLoginIdInputSettings = ({ children }: Props) => {
	const {
		nodeId,
		autoComplete,
		actions: { setProp }
	} = useNode((node) => ({
		nodeId: node.id,
		autoComplete: node.data.props.autoComplete
	}));

	// only one input is allowed to be enabled at the time
	const { isAutoCompleteDisabled } = useEditor((state) => ({
		isAutoCompleteDisabled: !!Object.keys(state.nodes).find(
			(id) =>
				id !== nodeId &&
				state.nodes[id].data.custom?.type === 'input' &&
				state.nodes[id].data.props.autoComplete
		)
	}));

	const onChange = useCallback(
		(isOn: boolean) => {
			setProp((props: { [x: string]: any }) => {
				props.autoComplete = isOn ? 'webauthn' : null;
			});
		},
		[setProp]
	);

	return (
		<EditorInputSettings>
			<>
				<SwitchControl
					disabled={isAutoCompleteDisabled}
					value={!!autoComplete}
					label={intl.tr('screenEditor.settings.input.passkeysAutocomplete')}
					setValue={onChange}
					helpTooltip={intl.tr(
						'screenEditor.settings.input.passkeysAutocomplete.tooltipText'
					)}
					order={60}
				/>
				{children}
			</>
		</EditorInputSettings>
	);
};

export { EditorLoginIdInputSettings };
